<div class="alert alert-light alert-dismissible fade show" role="alert">
  <small>
    <strong>{{ title }} !</strong>
    <ng-content></ng-content>
  </small>

  <button
    *ngIf="closable"
    type="button"
    class="btn-close"
    data-bs-dismiss="alert"
    aria-label="Close"
    (click)="onClose()"
  ></button>
</div>
